import { NavLink, useLocation } from "react-router-dom";
import {
  Calculator,
  ClockCounterClockwise,
  Database,
  Gear,
  SignOut,
  User,
  ShieldCheck,
  UsersThree,
  Sparkle,
  BookOpenText,
} from "@phosphor-icons/react";
import { useAuth } from "../contexts/AuthContext";

const NavItem = ({ to, icon: Icon, label, testId }) => (
  <NavLink
    to={to}
    end={to === "/"}
    data-testid={testId}
    className={({ isActive }) =>
      `flex items-center gap-2 px-3 py-2 rounded text-sm font-medium transition-colors ${
        isActive
          ? "bg-[#0A3F9A] text-white"
          : "text-slate-700 hover:bg-slate-100"
      }`
    }
  >
    <Icon size={16} weight="duotone" />
    {label}
  </NavLink>
);

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const isAdmin = user?.role === "admin";
  const location = useLocation();
  const isPrintRoute = location.pathname.startsWith("/print/");

  if (isPrintRoute) {
    // Bare layout for print page
    return (
      <div className="min-h-screen bg-white text-slate-900 print-area">
        {children}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F4F6F8] text-slate-900">
      <header className="app-header bg-white border-b border-slate-200 no-print">
        <div className="max-w-[1600px] mx-auto px-4 md:px-6 lg:px-8 py-3 flex items-center justify-between gap-6 flex-wrap">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded bg-[#0A3F9A] text-white flex items-center justify-center font-black">
              K
            </div>
            <div>
              <div className="text-sm font-bold leading-tight text-slate-900">
                Kalkulator Biaya Operasi
              </div>
              <div className="text-[11px] text-slate-500 uppercase tracking-wider">
                Tim Admission Rumah Sakit
              </div>
            </div>
          </div>
          <nav className="flex items-center gap-1 flex-wrap" data-testid="main-nav">
            <NavItem to="/" icon={Calculator} label="Kalkulator" testId="nav-kalkulator" />
            <NavItem
              to="/riwayat"
              icon={ClockCounterClockwise}
              label="Riwayat"
              testId="nav-riwayat"
            />
            <NavItem to="/ai" icon={Sparkle} label="Mode AI" testId="nav-ai" />
            <NavItem
              to="/knowledge"
              icon={BookOpenText}
              label="Knowledge AI"
              testId="nav-knowledge"
            />
            {isAdmin && (
              <>
                <NavItem
                  to="/admin/master"
                  icon={Database}
                  label="Master Data"
                  testId="nav-master"
                />
                <NavItem
                  to="/admin/users"
                  icon={UsersThree}
                  label="User"
                  testId="nav-users"
                />
                <NavItem
                  to="/admin/hospital"
                  icon={Gear}
                  label="Konfigurasi"
                  testId="nav-hospital"
                />
              </>
            )}
          </nav>
          {user && (
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-2 text-xs text-slate-600">
                {isAdmin ? (
                  <ShieldCheck size={14} weight="duotone" className="text-[#0A3F9A]" />
                ) : (
                  <User size={14} weight="duotone" />
                )}
                <span data-testid="text-current-user">
                  {user.name || user.username}{" "}
                  <span className="text-slate-400">
                    ({isAdmin ? "Admin" : "Staff"})
                  </span>
                </span>
              </div>
              <button
                onClick={logout}
                className="flex items-center gap-1.5 text-xs text-slate-600 hover:text-red-600 px-2 py-1 rounded hover:bg-slate-100 transition-colors"
                data-testid="btn-logout"
              >
                <SignOut size={14} weight="duotone" /> Keluar
              </button>
            </div>
          )}
        </div>
      </header>
      <main className="max-w-[1600px] mx-auto px-4 md:px-6 lg:px-8 py-6 print-area">
        {children}
      </main>
    </div>
  );
}
